import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (typeof window === 'undefined') return false;
 
  const token = localStorage.getItem('token');

  // Check if token exists and if it is expired
  if (!token || authService.hasTokenExpired()) {
    authService.logOut();
    router.navigate(['/authentication']);
    return false;
  }

  // Do not authorize a route until server-verified groups are available.
  const profileReady = await authService.ensureUserGroupsLoaded();
  if (!profileReady) {
    authService.logOut();
    return router.createUrlTree(['/authentication']);
  }

  // A B2B customer can only navigate to the main dashboard.
  // Route checks are retained even when navigation links are hidden.
  const requestedPath = state.url.split(/[?#]/, 1)[0].replace(/\/$/, '') || '/';
  if (authService.isB2bCustomer() && requestedPath !== '/' && requestedPath !== '/presentation-dashboard') {
    return router.createUrlTree(['/presentation-dashboard']);
  }

  const requiredRoles = route.data?.['requiredRoles'] || [];
  if (requiredRoles.length > 0 && !authService.hasAccess(requiredRoles)) {
    console.error('Access denied: insufficient permissions');
    router.navigate(['/unauthorized']);
    return false;
  }
  
  
  return true;
};
